import React from 'react';
import { TagLinkGroup } from '@core-ui/tag-link-group';
import propTypes from './types';
import RelatedCategoriesDivision from './styled/RelatedCategoriesDivision';
import { useRelatedCategories } from './context';

const RelatedCategories = ({ isBRRedesignEnabled }) => {
  const { categories, customLabel } = useRelatedCategories();

  const hasCategories = categories?.length > 0;

  return hasCategories ? (
    <RelatedCategoriesDivision isBRRedesignEnabled={isBRRedesignEnabled}>
      <TagLinkGroup
        className="tag-link-group"
        heading={customLabel}
        links={categories}
      />
    </RelatedCategoriesDivision>
  ) : null;
};

RelatedCategories.propTypes = propTypes;

export default RelatedCategories;
